<template>
  <div class="destination-detail">
    <state-spot v-if="isSpot" />
    <state-restroom v-if="isRestRoom" />
    <state-person v-if="isPerson" />
  </div>
</template>


<script>
import stateSpot from './state/spot.vue';
import stateRestroom from './state/restroom.vue';
import stateItem from './state/item.vue';
import statePerson from './state/person.vue';

export default {
  components: {
    stateSpot,
    stateRestroom,
    stateItem,
    statePerson,
  },
  computed: {
    isShow: ({ $store }) => $store.state.destinationDetail.isShow,
    currentDestination: ({ $store }) => $store.state.searchResult.destination,
    currentDestinationType: ({ $store }) => $store.state.searchResult.destination.type,
    isRestRoom: ({ currentDestinationType }) => currentDestinationType === 'Spot::RestroomSpot',
    isSpot: ({ currentDestinationType, isRestRoom }) => currentDestinationType && (currentDestinationType.indexOf('Spot') === 0) && !isRestRoom,
    isThing: ({ currentDestinationType }) => currentDestinationType && (currentDestinationType.indexOf('Thing') === 0),
    isItem: ({ isThing, currentDestination }) => isThing && currentDestination.item != null,
    isPerson: ({ isThing, currentDestination }) => isThing && currentDestination.user != null,
  },
};
</script>

<style scoped lang="scss">
.background {
  background: #fff;
}
.map-detail_close {
  padding: 40px 27px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// detail.vue?57cd48ca